import React from 'react';
import { CSSObject } from '@emotion/react';
import useTheme from '@hooks/useTheme';
import { injectTestId } from '@cvent/nucleus-test-automation';

interface SessionBannerProps {
  imageSrc?: string;
  imageAltText?: string;
}

const useStyles = ({ imageSrc }): Record<string, CSSObject> => {
  const { backgroundColor } = useTheme();

  return {
    bannerStyle: {
      alignItems: 'center',
      aspectRatio: '5.85625', // 1874 / 320 - our recommended image size
      backgroundColor: backgroundColor.active,
      display: 'flex',
      justifyContent: 'center',
      marginLeft: 'auto',
      marginRight: 'auto',
      overflow: 'hidden',
      position: 'relative',
      textAlign: 'center',
      width: '100%'
    },
    imageStyle: {
      height: 'auto',
      objectFit: 'cover',
      width: '100%'
    },
    sessionBannerWrapper: {
      display: imageSrc ? 'block' : 'none'
    }
  };
};

const testId = 'session-banner';

function SessionBanner({
  imageSrc,
  imageAltText = '' // default of empty string if no alt text is passed in
}: SessionBannerProps): JSX.Element {
  const { bannerStyle, imageStyle, sessionBannerWrapper } = useStyles({
    imageSrc
  });

  return (
    <div css={sessionBannerWrapper}>
      <div css={bannerStyle} {...injectTestId(`${testId}-container`)}>
        <img css={imageStyle} src={imageSrc} data-cvent-id={`${testId}-image`} alt={imageAltText} />
      </div>
    </div>
  );
}

export default SessionBanner;
